import { observer } from "mobx-react-lite";
import SquareStore from "./SquareStore";

const SquareView = observer(({ square }: { square: SquareStore }) => {
    return (
        <div
            className="color-square"
            data-x={square.x}
            data-y={square.y}
            style={{ backgroundColor: square.rgbaString }}
            onMouseDown={square.setColor}
        ></div>
    );
})

export default SquareView;